module.exports = __webpack_public_path__ + "static/media/4.171b332a.png";